import { render, staticRenderFns } from "./VmsMedecinManager.vue?vue&type=template&id=23a70860&"
import script from "./VmsMedecinManager.vue?vue&type=script&lang=js&"
export * from "./VmsMedecinManager.vue?vue&type=script&lang=js&"
import style0 from "./VmsMedecinManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports